<div *transloco="let t; scope: 'featureDataManagement'">
  <div class="flex gap-2 flex-col">
    <div id="enum-label" class="bd-label-small-gray">
      {{ t('featureDataManagement.attributesEditor.selectEnum.label') }}
    </div>
    @let hasError =
      (enumOptionsControl().dirty || enumOptionsControl().touched) &&
      enumOptionsControl().invalid;
    <p-inputgroup
      [ngClass]="{
        'bd-state-error': hasError,
      }"
    >
      <p-autocomplete
        inputId="enum-options"
        [formControl]="enumOptionsControl()"
        ariaLabelledBy="enum-label"
        [placeholder]="
          t('featureDataManagement.attributesEditor.selectEnum.placeholder')
        "
        fluid
        multiple
        class="bd-autocomplete"
        [typeahead]="false"
        (ngModelChange)="formatEnumValues()"
      >
        <ng-template let-enumOption #selecteditem>
          <div class="bd-label-regular" [attr.data-id]="'option-' + enumOption">
            {{ enumOption }}
          </div>
        </ng-template>
        <ng-template #removeicon>
          <i class="ui-close px-[2px]" data-id="remove-token-icon"></i>
        </ng-template>
      </p-autocomplete>
      <div class="bd-right-icons">
        @if (hasError) {
          <i
            class="ui-error bd-icon bd-error-icon"
            data-id="input-error-icon"
          ></i>
        }
      </div>
    </p-inputgroup>
    @if (hasError) {
      @for (key of errorKeys; track $index) {
        <bd-helper-text
          [attr.data-id]="'attributes-editor-enum-error-msg_' + key"
          [text]="
            t(
              `featureDataManagement.attributesEditor.selectEnum.validationMessages.${key}`
            )
          "
          state="error"
        ></bd-helper-text>
      }
    } @else {
      <bd-helper-text
        [text]="
          t('featureDataManagement.attributesEditor.selectEnum.instructions')
        "
        [state]="'default'"
      ></bd-helper-text>
    }
  </div>
</div>
